import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { PageWrapper, Loader, Alert } from "../../components";
import Actions, { thunks } from "../../redux/modules/appUsers";
import PincodeModal from "./components/pincodeModal";
import { getUserData } from "../../utils";

class Pincode extends React.Component {
  state = {
    pinCodeToDelete: null,
    pincodeList: [],
    userData: null,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    const userData = getUserData();
    console.log(userData);
    this.setState({ userData });
    dispatch(thunks.fetchWareHouse(userData.warehouseId));
  }

  fetchPincodes = (district) => {
    const { dispatch } = this.props;
    dispatch(thunks.fetchPincodes(district));
  };

  addPinCode = (data) => {
    const { dispatch } = this.props;
    const { userData } = this.state;
    dispatch(thunks.addPinCode([data.pincode], userData.warehouseId));
  };

  handleAddPinCode = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", true);
  };

  deletePinCode = (pinCode) => {
    this.setState({ pinCodeToDelete: pinCode });
  };

  handleDeletePinCode = () => {
    const { dispatch } = this.props;
    const { pinCodeToDelete, userData } = this.state;
    dispatch(thunks.deletePinCode([pinCodeToDelete.id], userData.warehouseId));
    this.setState({ pinCodeToDelete: null });
  };

  closeModal = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", false);
  };

  render() {
    const { list, loading, error, updateProperty, showModal, wareHouseList } =
      this.props;
    const { pinCodeToDelete } = this.state;
    return (
      <PageWrapper title="Pincode">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Pincode"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end mb-3">
                      <button
                        className="btn btn-primary"
                        onClick={this.handleAddPinCode}
                      >
                        <i className="fa fa-plus mr-2" />
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Post Office</th>
                          <th>Pincode</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wareHouseList?.deliveryData?.length ? (
                          wareHouseList?.deliveryData?.map((code) => (
                            <tr key={code.id}>
                              <td>{code.id}</td>
                              <td>{code.name}</td>
                              <td>{code.code}</td>
                              <td onClick={() => this.deletePinCode(code)}>
                                <i className="fa fa-trash text-danger" />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PincodeModal
          show={showModal}
          onHide={this.closeModal}
          addPinCode={this.addPinCode}
          pincodeList={list}
          fetchPincodes={this.fetchPincodes}
        />

        <Alert
          show={!!pinCodeToDelete}
          onHide={() => this.setState({ pinCodeToDelete: null })}
          title="Delete Pincode"
          message={`Are you sure you want to delete Pincode ID: ${
            (pinCodeToDelete || {}).id
          }?`}
          onSubmit={this.handleDeletePinCode}
        />
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  appUsers: { loading, error, list, nextPageToken, showModal, wareHouseList },
}) => ({
  loading,
  error,
  list,
  nextPageToken,
  showModal,
  wareHouseList,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Pincode);
